import { Action as AnyAction } from '@reduxjs/toolkit';
import { getUserProfileFailed, getUserProfileSuccess, signInFailed, signInSuccess } from './auth.action';

export type User = {
    first_name: string;
    last_name: string;
    username: string;
};

export type AuthState = {
    readonly accessToken: string | null;
    readonly userProfile: User | null;
};

const INITIAL_STATE: AuthState = {
    accessToken: null,
    userProfile: null,
};

export const authReducer = (state = INITIAL_STATE, action: AnyAction) => {
    if (getUserProfileSuccess.match(action) || signInSuccess.match(action)) {
        return { ...state, ...action.payload };
    }

    if (
        signInFailed.match(action) ||
        getUserProfileFailed.match(action)
    ) {
        return { ...state, accessToken: null, userProfile: null };
    }

    return state;
};